import {initializeApp} from 'firebase/app';
import {getMessaging, getToken} from 'firebase/messaging';
import {firebaseConfig} from "../utils/FirebaseConfig";

const appFirebase = initializeApp(firebaseConfig);

export const messaging = getMessaging(appFirebase)

export const requestForNotificationPermission = async () => {
    try {
        return await Notification.requestPermission()
    } catch (error) {
        console.error("Error occurred while retrieving token: ", error)
    }
};

export const requestForToken = async (registration: ServiceWorkerRegistration) => {
    try {
        const token = await getToken(
            messaging,
            {
                vapidKey: 'BH0c6JcpirYljGQuqj2Og8vfuFt0VVC7YBmdQaTENV2aXwbN8n2mZhjixe7U3lyN_tm3Ev6_GKxlx3vbedNaEPc',
                serviceWorkerRegistration: registration
            }
        )

        localStorage.setItem('fcmToken', token)
        console.log("FCM Token:", token)
    } catch (error) {
        console.error("Error occurred while retrieving token: ", error)
    }
}
